import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const SelectModeUniteIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M22 8.25H15.75V2C15.75 1.59 15.41 1.25 15 1.25H2C1.59 1.25 1.25 1.59 1.25 2V15C1.25 15.41 1.59 15.75 2 15.75H8.25V22C8.25 22.41 8.59 22.75 9 22.75H22C22.41 22.75 22.75 22.41 22.75 22V9C22.75 8.59 22.41 8.25 22 8.25Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

SelectModeUniteIcon.displayName = 'SelectModeUniteIcon';
